export const PAPI_FIELDS = ['fullName', 'job', 'employeeID', 'managerName', 'managerAlias'];
